import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo_news_factory.svg';
import { useSelector } from 'react-redux';
import { RootState } from '../rootReducer';
import Logout from '../logout/Logout';

function Header() {
    const userEmail = useSelector((state: RootState) => state.user.email);
    const isSsoUser = useSelector((state: RootState) => state.user.isSsoUser);
    const name = userEmail?.split('@')[0];
    const [isDropdownOpen, setDropdownOpen] = useState(false);
    const toggleDropdown = () => setDropdownOpen(!isDropdownOpen);

    useEffect(() => {
        if (!userEmail) {
            setDropdownOpen(false);
        }
    }, [userEmail]);

    return (
        <div className="inline-flex items-center justify-between w-full bg-white h-[7vh] px-6 py-3 relative">
            <a href={userEmail ? '/dashboard' : '/login'}>
                <img src={logo} className="w-[200px] max-w-[250px] h-full" alt="newsfactory_logo" />
            </a>
            {userEmail && !isSsoUser ? (
                <div className="relative">
                    <button
                        className="flex flex-row flex-nowrap items-baseline content-center rounded-[1.5rem] px-4 py-2 text-small leading-6 bg-light-gray "
                        onClick={toggleDropdown}
                    >
                        <span className="mr-1">
                            {name ? name.charAt(0).toUpperCase() + name.slice(1) : name}
                        </span>
                        <span className="flex relative w-[6px] h-[6px] border-t-2 border-l-2 border-dark-gray rounded-[10%] transition-all duration-300 ease-in-out m-[5px] rotate-[225deg]" />
                    </button>
                    {isDropdownOpen && (
                        <div className="absolute right-0 w-full bg-primary shadow-lg z-[1] rounded-[12px] text-center mt-[5px] uppercase font-primary text-small font-medium py-[5px]">
                            <Logout />
                        </div>
                    )}
                </div>
            ) : !isSsoUser ? (
                <Link
                    className="flex flex-row items-baseline rounded-[1.5rem] px-4 py-2 text-[16px] leading-6"
                    to={'login'}
                >
                    {' '}
                    Login{' '}
                </Link>
            ) : (
                <></>
            )}
        </div>
    );
}

export default Header;
